import { Component, OnInit, Optional, Inject } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { HistoryCommunicateService } from '../../services/History-communicate.services';

@Component({
    selector: 'new-history-filter',
    templateUrl: './history-filter.component.html',
    styleUrls: ['history-filter.component.css']
})

export class NewHistoryFilterComponent  implements OnInit {
    errorMsg: boolean = false;
    error: boolean = false;
    symbol: String;
    toDate: any;
    downloadLink: any;
    checkbox: boolean = false;
    fromDate: any;
    checkboxActive: boolean = true;
    dateActive: boolean = false;
    timePeriod: String = 'SEVEN_DAYS';
    ismobile: boolean = false;
    showFilter: boolean = true;
    isAdaTheme: boolean = false;
    timePeriodOptions: any = {
        'INTRADAY' : 'Today',
        'PRIOR_DAY' : 'Previous Business Day',
        'SEVEN_DAYS' : 'Last 7 Days',
        'THIRTY_DAY' : 'Last 30 Days',
        'SIXTY_DAY' : 'Last 60 Days',
        'NINETY_DAY' : 'Last 90 Days',
        'CURRENT_YEAR' : 'Current Year',
        'PRIOR_YEAR' : 'Prior Year',
        'ALL_DATES' : 'All',
        'DATE_RANGE' : 'Custom'};
    timePeriodKeys: any[] = Object.keys(this.timePeriodOptions);
    transaction: String = 'ALL';
    transactionOptions: any = {
        'ALL' : 'All',
        'SECURITY' : 'Security Transactions',
        'WITH_DEPOSIT' : 'Withdrawals & Deposits',
        'DIV_INT' : 'Dividends & Interest',
        'COMM_STK' : 'Common Stocks',
        'PREF_STK' : 'Preferred Stocks',
        'OPTIONS' : 'Options',
        'MF' : 'Mutual Funds',
        'BONDS' : 'Bonds',
        'CD' : 'CD\'s',
        'OTHER' : 'Other'};
        transactionKeys: any[] = Object.keys(this.transactionOptions);
    currentTimestamp: any;
    constructor(private historycommunicate: HistoryCommunicateService, private translationService: PershingTranslationService,
                @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
            this.ismobile = true;
        }
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.isAdaTheme = true;
        }
    }

    ngOnInit() {
        this.DispData();
        if (this.historycommunicate.subsVar3 === undefined) {
            this.historycommunicate.subsVar3 = this.historycommunicate.
            download.subscribe((name: string) => {
            this.getlink();
            });
          }
    }

    timePeriodSelect() {
        if (this.timePeriod === 'DATE_RANGE') {
            this.dateActive = true;
        }else {
            this.dateActive = false;
            this.fromDate = undefined;
            this.toDate = undefined;
        }
    }

    transactionSelect() {
        if (this.transaction === 'ALL' || this.transaction === 'WITH_DEPOSIT') {
            this.checkboxActive = true;
        }else {
            this.checkboxActive = false;
            this.checkbox = false;
        }
    }

    DispData() {
        if ( this.symbol === undefined) {
            this.symbol = '';
        }
        let fromDate = String(this.fromDate).replace('-', '');
        fromDate = fromDate.replace('-', '');
        let toDate = String(this.toDate).replace('-', '');
        toDate = toDate.replace('-', '');
        let error = this.validate();
        if (!error) {
            this.showFilter = !this.showFilter;
            this.historycommunicate.setParameters(this.symbol, this.timePeriod, fromDate, toDate, this.transaction, this.checkbox);
        }
    }

    getlink() {
        this.downloadLink = this.historycommunicate.getDownloadLink();
        this.currentTimestamp = this.historycommunicate.getAsOf();
    }

    validate() {
        this.error = false;
        this.errorMsg = false;
        if (this.dateActive === true && (this.toDate === undefined || this.fromDate === undefined)) {
            this.errorMsg = false;
            this.error = true;
            return true;
        }
        if (this.fromDate > this.toDate) {
            this.errorMsg = true;
            this.error = false;
            return true;
        }
        return false;
    }
}
